import { axiosInstance } from '../../config/axiosConfig';
import { AxiosError, AxiosResponse } from 'axios';
import {
    IClassVariationsResponse,
    IClientLineOfBusinessesResponse,
    IClientLobVariationsResponse,
    ICoreTaxResponse,
    ICoreTaxesRequest,
    ILobCoreTaxesRequest,
    ICountriesRepsonse,
    IRegionsRepsonse,
    ISubRegionsRepsonse,
    ITaxResponse,
    InsuranceClassesResponse,
    IUnderWrittingStatusRequest,
    IUnderWrittingStatusResponse,
    IExportCoreTaxesRequest,
} from '../types/rate.type';
import { endPointUrls } from '../constants/endPoints';

const getCountries = (): Promise<ICountriesRepsonse> => {
    return axiosInstance
        .get(endPointUrls.getCountries)
        .then((res: AxiosResponse<ICountriesRepsonse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getRegions = (countryCodes: string[]): Promise<IRegionsRepsonse> => {
    return axiosInstance
        .get(endPointUrls.getRegions, { params: { countryCodes: countryCodes.join(',') } })
        .then((res: AxiosResponse<IRegionsRepsonse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getSubRegions = (regionIds: string[]): Promise<ISubRegionsRepsonse> => {
    return axiosInstance
        .get(endPointUrls.getSubRegions, { params: { regionIds: regionIds.join(',') } })
        .then((res: AxiosResponse<ISubRegionsRepsonse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getInsuranceClasses = (): Promise<InsuranceClassesResponse> => {
    return axiosInstance
        .get(endPointUrls.getInsuranceClasses)
        .then((res: AxiosResponse<InsuranceClassesResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getClassVariations = (
    code: string,
    effectiveDate: Date | string,
    regionId?: string,
    subRegionId?: string,
): Promise<IClassVariationsResponse> => {
    return axiosInstance
        .get(endPointUrls.getClassVariations + code, { params: { regionId, subRegionId, effectiveDate } })
        .then((res: AxiosResponse<IClassVariationsResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getCoreTaxes = (reqBody: ICoreTaxesRequest): Promise<ICoreTaxResponse> => {
    return axiosInstance
        .post(endPointUrls.getCoreTaxes, reqBody)
        .then((res: AxiosResponse<ICoreTaxResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getLobCoreTaxes = (reqBody: ILobCoreTaxesRequest): Promise<ICoreTaxResponse> => {
    return axiosInstance
        .post(endPointUrls.getLobCoreTaxes, reqBody)
        .then((res: AxiosResponse<ICoreTaxResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getUnderwritingStatus = (reqBody: IUnderWrittingStatusRequest): Promise<IUnderWrittingStatusResponse> => {
    return axiosInstance
        .post(endPointUrls.getUnderwritingStatus, reqBody)
        .then((res: AxiosResponse<IUnderWrittingStatusResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const exportCoreTaxes = (reqBody: IExportCoreTaxesRequest): Promise<any> => {
    return axiosInstance
        .post(endPointUrls.exportCoreTaxes, reqBody, { responseType: 'blob' })
        .then((res: AxiosResponse<any>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getCoreTaxById = (id: string): Promise<ITaxResponse> => {
    return axiosInstance
        .get(endPointUrls.getCoreTaxById + id)
        .then((res: AxiosResponse<ITaxResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getClientLineOfBusinesses = (): Promise<IClientLineOfBusinessesResponse> => {
    return axiosInstance
        .get(endPointUrls.getClientLineOfBusinesses)
        .then((res: AxiosResponse<IClientLineOfBusinessesResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getClientLobVariations = (
    countryCode: string,
    effectiveDate: Date | string,
    regionId?: string,
    subRegionId?: string,
): Promise<IClientLobVariationsResponse> => {
    return axiosInstance
        .get(endPointUrls.clientLobVariations, {
            params: { countryCode, regionId, subRegionId, effectiveDate },
        })
        .then((res: AxiosResponse<IClientLobVariationsResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const rateFinderServices = {
    getCountries,
    getRegions,
    getSubRegions,
    getInsuranceClasses,
    getClassVariations,
    getCoreTaxes,
    getLobCoreTaxes,
    getUnderwritingStatus,
    exportCoreTaxes,
    getCoreTaxById,
    getClientLineOfBusinesses,
    getClientLobVariations,
};

export default rateFinderServices;
